module.exports = __webpack_public_path__ + "img/404.03f76b27.jpg";